/* =========================================================
   Puddi Base JS
   Site-wide behaviors: scroll reveal.
   Loaded with `defer` so DOM is parsed before this runs.
   ========================================================= */

(function () {
  'use strict';

  // Respect user preference — no reveal animation if reduced-motion is set.
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  // Reveal threshold: fire when 12% of the section has entered the viewport.
  // Matches homepage fidelity V6.
  var REVEAL_THRESHOLD = 0.12;

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('on');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: REVEAL_THRESHOLD });

  document.querySelectorAll('.reveal').forEach(function (el) {
    revealObserver.observe(el);
  });
})();
